import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const CardItem = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: .5rem 1rem 1rem 1rem;
  border: 3px solid #c0c0c0;
  border-radius: 5px;
`

export const GridProductInfo = styled.div`
  display: grid;
  grid-template-columns: .9fr 2fr .6fr .6fr;
  gap: 1.5rem;
  justify-content: space-between;
`

export const CustomTextField = styled(TextFieldMui)`
`
